import * as React from "react";
import { IProduct } from "~/types/product";
import ProductTile from "~/components/product-tile/product-tile";
import SliderSwiper from "~/components/swiper/slider-swiper";
import { breakpoints } from "~/utils/breakpoint-utils";
import { Settings } from "react-slick";
import ArrowLink from "../arrow-link/arrow-link";
import ContentSection from "../content-section/content-section";
import classNames from "classnames";
import Tag from "../tag/tag";

export interface IProductSliderProps {
    title?: string;
    viewMoreLink?: string;
    products: IProduct[];
    // addToBasketWebApiUrl: string;
    // secondaryPriceLabel?: string;
    disableBackgroundColor?: boolean;
    singleItemHighlight?: boolean;
    // discountPaddings?: boolean;
    anchorId?: string;
    btnIsLarge?: boolean;
    infoLabel?: string;
}

const initialConfigObject = { haveStatus: false };

const setConfigurationObjectFromProducts = (accumulator: typeof initialConfigObject, product: IProduct) => {
    accumulator.haveStatus = !!product.status || accumulator.haveStatus;

    return accumulator;
};

const ProductSlider: React.FC<IProductSliderProps> = ({
    title,
    viewMoreLink,
    products,
    // addToBasketWebApiUrl,
    // secondaryPriceLabel,
    disableBackgroundColor,
    singleItemHighlight,
    // discountPaddings,
    btnIsLarge,
    ...props
}) => {
    const swiperSettings: Settings = {
        slidesToShow: singleItemHighlight ? products.length : 5.2,
        swipeToSlide: true,
        lazyLoad: "ondemand",
        initialSlide: 0,
        responsive: [
            {
                breakpoint: breakpoints.rat,
                settings: {
                    slidesToShow: 1.2
                }
            },
            {
                breakpoint: breakpoints.rabbit,
                settings: {
                    slidesToShow: 1.5
                }
            },
            {
                breakpoint: breakpoints.dog - 1,
                settings: {
                    slidesToShow: 2.3
                }
            },
            {
                breakpoint: breakpoints.lion,
                settings: {
                    slidesToShow: singleItemHighlight ? products.length : 3.3
                }
            },
            {
                breakpoint: breakpoints.horse,
                settings: {
                    slidesToShow: singleItemHighlight ? products.length : 4.3
                }
            }
        ]
    };

    const headerTitle = title && (
        <h2 className="product-slider__title h2-style" dangerouslySetInnerHTML={{ __html: title }} />
    );
    const headerLink = viewMoreLink && <ArrowLink className="product-slider__link" link={viewMoreLink} />;

    const baseClass = "product-slider";

    const someProducts = React.useMemo(
        () => products.reduce(setConfigurationObjectFromProducts, initialConfigObject),
        [products]
    );

    const productSliderClasses = classNames(baseClass, `${baseClass}--n-products-${products.length}`);

    return (
        <ContentSection className={productSliderClasses} {...props}>
            {(headerTitle || headerLink) && (
                <div className={`${baseClass}__header`}>
                    <div className={`${baseClass}__header-inner`}>
                        {headerTitle}
                        {props.infoLabel && (
                            <Tag className={`${baseClass}__info-label`} type="UPCOMING" shape="square">
                                {props.infoLabel}
                            </Tag>
                        )}
                    </div>
                    {headerLink}
                </div>
            )}
            {products.length > 0 && (
                <SliderSwiper className={productSliderClasses} settings={swiperSettings}>
                    {products.map((product, index) => (
                        <div key={index} className={`${baseClass}__item`}>
                            <ProductTile
                                {...product}
                                btnIsLarge={btnIsLarge}
                                ctaLink={singleItemHighlight ? product.ctaLink : undefined}
                                className={`${baseClass}__product-tile`}
                                // secondaryPrice={product.secondaryPrice}
                                // secondaryPriceLabel={secondaryPriceLabel}
                                // stockStatusLabel={product.stockStatusLabel}
                                // numberOfProductsLabel={product.numberOfProductsLabel}
                                // ctaLabel={product.primaryPrice}
                                // addToBasketWebApiUrl={addToBasketWebApiUrl}
                                hideBackground={disableBackgroundColor}
                                hideStatus={!someProducts.haveStatus}
                                hasTopPadding={someProducts.haveStatus}
                                // bottomPaddedSubText={someProducts.haveSubText}
                                // hasBottomPaddingNumberOfProducts={someProducts.haveNumberOfProductsLabel}
                                singleItemHighlight={singleItemHighlight}
                                sizes="150px"
                                trackingList="Product Slider"
                                trackingPosition={index + 1}
                            />
                        </div>
                    ))}
                </SliderSwiper>
            )}
        </ContentSection>
    );
};

export default React.memo(ProductSlider);
